import { gql } from '@apollo/client';

const APPRAISERS_DATA_FOR_EVENT = gql`
  query AppraisersDataForEvent($eventId: Int!) {
    appraisersDataForEvent(eventId: $eventId) {
      ExternalUserId
      State
      Country
      Observation
      AdditionalInformation
      TimeZoneDisplayName
      DomainExperienceSummaryList {
        Domain
        TotalYearsOfExperience
        HighestRole
      }
    }
  }
`;

export default APPRAISERS_DATA_FOR_EVENT;
